import React from 'react';
import passwordStrength from "../../libs/passwordStrength";

const PasswordStrength= ({password=""})=>{
    let passwordValidity = passwordStrength(password);
    return  (
        <div className="pb-16">
            <p className={passwordValidity.validation.long ? "text-success" : "text-danger"}>* Au moins 8 caractères.</p>
            <p className={passwordValidity.validation.uppercase ? "text-success" : "text-danger"}>* 1 majuscule minimum.</p>
            <p className={passwordValidity.validation.lowercase ? "text-success" : "text-danger"}>* 1 minuscule minimum.</p>
            <p className={passwordValidity.validation.digit ? "text-success" : "text-danger"}>* 1 chiffre minimum.</p>
            <p className={passwordValidity.validation.special ? "text-success" : "text-danger"}>* 1 caractère spécial minimum (Au choix : Arobase, Point exclamation/interrogation, parenthèse etc. ).</p>
        </div>
    )
}

export default PasswordStrength;